   <app-not-verified 
        [callingfrom]="callingfrom" 
        (emitButtonClicked)="buttonClicked()"
        *ngIf="dataObj?.type=='not_verified'" 
        [dataObj]="dataObj">
    </app-not-verified>

    <app-map-association 
        [callingfrom]="callingfrom"
        (emitButtonClicked)="buttonClicked()"
        *ngIf="dataObj?.type=='map_association'" 
        [dataObj]="dataObj">
    </app-map-association>
    
    <app-verification-under-process 
        [callingfrom]="callingfrom" 
        (emitButtonClicked)="buttonClicked()"
        *ngIf="dataObj?.type=='verification_under_process'" 
        [dataObj]="dataObj">
    </app-verification-under-process>

    <app-verified *ngIf="dataObj?.type=='verified'" 
        [dataObj]="dataObj">
    </app-verified>

    <app-generic-card 
        [callingfrom]="callingfrom" 
        (emitButtonClicked)="buttonClicked()"
        *ngIf="dataObj?.type=='generic' || dataObj?.type=='profile_incompleted'" 
        [dataObj]="dataObj">
    </app-generic-card>